import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ItemService } from '@services/item.service';
import { NotificationService } from '@services/notification.service';
import { RoleManagementService } from '@services/role.management.service';
import { TestService } from '@services/test.service';
import { WebErrorService } from '@services/webError.service';
import { DelMessageComponent } from 'src/app/shared/del-message/del-message.component';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ScoringTypeEnum } from '@configs/questions.config';

@Component({
  selector: 'app-tests-settings',
  templateUrl: './tests-settings.component.html',
  styleUrls: ['./tests-settings.component.scss'],
})
export class TestsSettingsComponent implements OnInit{

  selectedLang;
  testSettingsForm: FormGroup;
  testUUID: any;
  testDetailData: any;
  lstItemCategoryMaster: any;
  testStatusList: any;
  messageFlag = false;
  success = false;
  error = false;
  itemStatusId = 2;
  defaultStatus: any;
  testDetailSubscription: Subscription;
  // feedBackQuestion = false;
  // testQuestion = false;
  // demographic = false;
  currentIdBackup: string;
  statusName: any;
  isPublished: boolean;
  testItemGroupQuestionHideRequests: any[] = [];
  ScoringTypeEnum = ScoringTypeEnum;
  @Input() tabData: any;
  @Input() set testDetails(data: any) {
    if (data) {
      this.testDetailData = data.data;
      this.testService.getTestDetails(this.testDetailData.testuuId).subscribe(resData => {
        this.lstItemCategoryMaster = resData.data.lstItemCategoryMaster;
        let groupList = [];

        groupList = this.lstItemCategoryMaster.sort((a, b) => (a.itemCategoryOrderToRender - b.itemCategoryOrderToRender));
        groupList.push(groupList.splice(0, 1)[0])
        this.lstItemCategoryMaster = [];
        this.lstItemCategoryMaster = groupList;
        this.testItemGroupQuestionHideRequests = [];
        this.lstItemCategoryMaster.forEach(element => {
          if (element.enablequestionsequencing == true) {
            this.testItemGroupQuestionHideRequests.push({
              ItemGroupId: element.itemCategoryid,
              EnableQuestionSequencing: element.enablequestionsequencing
            });
          }
        });
      });

      // this.lstItemCategoryMaster = data.data.lstItemCategoryMaster;
      // let groupList = [];
      // groupList = this.lstItemCategoryMaster.sort((a, b) => (a.itemCategoryOrderToRender - b.itemCategoryOrderToRender));
      // groupList.push(groupList.splice(0, 1)[0])
      // this.lstItemCategoryMaster = [];
      // this.lstItemCategoryMaster = groupList;

      // this.testItemGroupQuestionHideRequests = [];
      // this.lstItemCategoryMaster.forEach(element => {
      //   if (element.enablequestionsequencing == true) {
      //     this.testItemGroupQuestionHideRequests.push({
      //       ItemGroupId: element.itemCategoryid,
      //       EnableQuestionSequencing: element.enablequestionsequencing
      //     });
      //   }
      // });

      this.statusName = this.testDetailData.statusId;
      this.testService.getTestStatusList()?.subscribe((data) => {
        this.testStatusList = data?.statuslist;
        this.defaultStatus = data?.statuslist[1]?.itemStatusId;
        this.testUUID = this.actRoute.snapshot.paramMap.get('id');

        if (this.testDetailData) {
          this.defaultStatus = this.testDetailData?.statusId; // Used to set published value
          this.isPublished = this.testDetailData?.statusId === data?.statuslist[0]?.itemStatusId;

          if (this.tabData) { this.messageFlag = false; }
          this.testSettingsForm = new FormGroup({
            testDuration: new FormControl(this.testDetailData?.duration, [Validators.required, Validators.pattern('^[0-9]*$')]),
            passingCriteria: new FormControl(this.testDetailData?.passingCriteria, [Validators.required, Validators.pattern('^[0-9]*$')]),
            shuffle: new FormControl(this.testDetailData?.shuffle),
            calculatorRequired: new FormControl(this.testDetailData?.calculatorRequired),
            penaltyPoints: new FormControl(this.testDetailData?.penaltyPoints),
            showItemCount: new FormControl(this.testDetailData?.showItemCount),
            submitredirecturl: new FormControl(this.testDetailData?.submitredirecturl),
            cancelRedirecturl: new FormControl(this.testDetailData?.cancelRedirecturl),
            testStatus: new FormControl(this.testDetailData?.statusId),
            language: new FormControl(this.testDetailData?.langId)
          });
          // this.testQuestion = this.testDetailData?.hidetestquestions;
          // this.feedBackQuestion = this.testDetailData?.hidefeedbackquestions;
          // this.demographic = this.testDetailData?.hidedemographicquestions;
          this.defaultStatus = this.testDetailData.statusId;
          this.testService.updateStatus(this.isPublished);
        }
      },
        (error: any) => {
          this.webErrorService.handleAPIErrors(error);
        });

    }
  }
  languageData = []
  languageId : any;
  languageLabel: any;
  @Output() public isTestDetails = new EventEmitter<any>();

  constructor(
    private testService: TestService,
    private actRoute: ActivatedRoute,
    private dialog: MatDialog,
    private webErrorService: WebErrorService,
    private notificationService: NotificationService,
    private itemService: ItemService,
    public roleSer: RoleManagementService,
    public translate: TranslateService
  ) {
    this.itemService.Allitemgrouplist.subscribe(a => {
      let groupList = [];
      if (this.testDetailData != undefined) {
        this.testDetailData.lstItemCategoryMaster.forEach(element => {
          if (element.itemCategoryName === "Others") {
            groupList.push(element);
          }
        });

        if (a != "") {
          a.forEach(element => {
            if (!groupList.includes(element)) {
              groupList.push({
                itemCategoryOrderToRender: element.itemGroupOrder, enablequestionsequencing: element.enableQuestionSequencing,
                itemCategoryName: element.itemGroupName, itemCategoryId: element.itemGroupId, scoringTypeId: element.scoringTypeId
              })
            }
          });
        }

        groupList = groupList.sort((a, b) => (a.itemCategoryOrderToRender - b.itemCategoryOrderToRender));
        groupList.push(groupList.splice(0, 1)[0])
        this.lstItemCategoryMaster = [];
        this.lstItemCategoryMaster = groupList;
      }
    });
  }

  ngOnInit(): void {
    this.testService.getLanguage().subscribe(data=> {
      this.languageData = data.items;
    });
    // Set langId here for default dropdown value
    this.selectedLang = this.testDetailData.langid;
  }

  get f() {
    return this.testSettingsForm.controls;
  }

  switchLang(event: any) {
    this.languageId = event.target.options[event.target.selectedIndex].dataset.id;
  }

  openConfirmationDialog(selectedStatus: any) {
    let data = this.testStatusList.filter(d => d.itemStatusId === selectedStatus);
    if (data[0].itemStatusId == this.testStatusList[0]?.itemStatusId) {
      const dialogSubscription = this.dialog.open(DelMessageComponent,
        {
          data: {
            message: this.translate.instant('testId.TabSettings.deletePopup.message'),
            buttonText: {
              ok: this.translate.instant('testId.TabSettings.deletePopup.btnYes'),
              cancel: this.translate.instant('testId.TabSettings.deletePopup.btnNo')
            }
          }
        }).afterClosed()
        .subscribe((confirmed: boolean) => {
          if (confirmed) {
            this.itemStatusId = data[0].itemStatusId;
          } else {
            // this.defaultStatus = this.testStatusList[1]?.itemStatusId;
            this.statusName = this.testStatusList[1]?.itemStatusId;
          }
        }, () => { }, () => dialogSubscription.unsubscribe());
    } else {
      this.itemStatusId = data[0].itemStatusId;
    }
  }

  finalSaveTestSettigs() {
    if (this.roleSer.accessData && this.roleSer.accessData.insertAllowed || this.roleSer.accessData.updateAllowed) {
      const apiData = {
        active: true,
        calculatorRequired: this.testSettingsForm.value.calculatorRequired,
        cancelRedirecturl: this.testSettingsForm.value.cancelRedirecturl,
        duration: this.testSettingsForm.value.testDuration,
        passingCriteria: this.testSettingsForm.value.passingCriteria,
        durationDisplay: '',
        durationapplicable: true,
        penaltyPoints: this.testSettingsForm.value.penaltyPoints,
        showItemCount: this.testSettingsForm.value.showItemCount,
        shuffle: this.testSettingsForm.value.shuffle,
        submitredirecturl: this.testSettingsForm.value.submitredirecturl,
        teststatus: (this.testSettingsForm.value.testStatus = this.itemStatusId),
        testItemGroupQuestionHideRequests: this.testItemGroupQuestionHideRequests,
        langId: this.languageId
        // TestQuestions: this.testQuestion,
        // FeedbackQuestions: this.feedBackQuestion,
        // DemographicQuestions: this.demographic
      };



      const saveSubscription = this.testService.saveTestSettings(apiData, this.testUUID).subscribe(
        (resData) => {
          if (resData) {
            this.notificationService.success(resData?.message);
            this.itemService.getItemStatus().subscribe((getStatus) => {
              getStatus?.items.forEach((statusData: any) => {
                if (resData?.data?.teststatus == statusData?.itemStatusId) {
                  debugger
                  this.defaultStatus = statusData?.itemStatusId; // this is for selected status
                }
              });
              this.isPublished = this.defaultStatus === this.testStatusList[0]?.itemStatusId;
              this.testService.updateStatus(this.isPublished);
              this.isTestDetails.emit(true);
            });
          }
        },
        (error) => this.webErrorService.handleAPIErrors(error, null, true, 'warn'), () => saveSubscription.unsubscribe()
      );
    };
  }

  ngOnDestroy() {
    this.isPublished = null;
  }

  categoryChange(event, data) {
    let group = this.testItemGroupQuestionHideRequests.filter(x => x.ItemGroupId === data.itemCategoryid)
    if (group.length == 0) {
      this.testItemGroupQuestionHideRequests.push({
        ItemGroupId: data.itemCategoryid,
        EnableQuestionSequencing: event.checked
      })
    } else {
      this.testItemGroupQuestionHideRequests.filter(x => x.ItemGroupId === data.itemCategoryid)[0].EnableQuestionSequencing = event.checked;
    }
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 ||(k >= 48 && k <= 57) ||  k == 46);
  }

  replace2Decimal(event: any, o, type: any){
    let value = event.target.value;
    if (event.key == '.') value = value + event.key;
    if(value == '.') value = "";
    var ponto = value.split('.').length;

    if (ponto > 2) value = value.substr(0, (value.length)-1);

    value = value.replace(/[^0-9.-]/,'');

    if (ponto == 2) value = value.substr(0,(value.indexOf('.')+3));

    if (type == 'options') o.correctPoints = parseFloat(value);
    if (type == 'minimumScore') {
      let num = value.substr(value.length - 1);
      if (num != '.') this.testSettingsForm.controls.passingCriteria.setValue(parseFloat(value))
    }
  }
}
